import marketplacePropertiesService from './MarketplacePropertiesService';

const a11yIIBFocusHandoffService = {
    /**
     * Checks if Accessibility (A11Y) IIB Focus Handoff is enabled.
     * Allows candidates to use Tab/Shift+Tab to move focus seamlessly between
     * the Test Player application and Iceworm toolbar.
     * @returns {boolean}
     */
    isA11yIIBFocusHandoffEnabled() {
        return Boolean(marketplacePropertiesService.isEnableA11yIIBFocusHandoff());
    },
};

export default a11yIIBFocusHandoffService;
